import s from './Contact.module.scss';
import InstagramLogo from '../components/InstagramLogo';
import LineLogo from '../components/LineLogo';
import { useLanguage } from '../contexts/LanguageContext';
import { contactText } from '../i18n/contact';
import { INSTAGRAM_URL, LINE_URL } from '../config/socialLinks';
import { trackCtaClick } from '../utils/analytics';

const ClockIcon = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8" />
    <path d="M12 7v5l3 2" />
  </svg>
);

const PlaneIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M21 3L3 11l7 2 2 7 9-17z" />
  </svg>
);

const CameraIcon = () => (
  <svg viewBox="0 0 24 24">
    <rect x="4" y="7" width="16" height="12" rx="3" />
    <path d="M8 7l1.5-2h5L16 7" />
    <circle cx="12" cy="13" r="3.5" />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M9 18L15 12L9 6" />
  </svg>
);

const TextLines = ({ lines }) => (
  <>
    {lines.map((line, index) => (
      <span key={`${line}-${index}`}>
        {line}
        {index < lines.length - 1 && <br />}
      </span>
    ))}
  </>
);

const Contact = () => {
  const { lang } = useLanguage();
  const t = contactText[lang] || contactText.JP;

  return (
    <section className={s.root}>
      <div className={s.container}>
        <span className={s.subTitle}>
          {t.subTitle}
        </span>

        <h2>
          {t.title}
        </h2>

        <p className={s.description}>
          {t.description}
        </p>

        <div className={s.infoBox}>
          <div className={s.infoItem}>
            <div className={s.infoIcon}>
              <ClockIcon />
            </div>

            <div>
              <h4>
                {t.info.hours.title}
              </h4>

              <p>
                <TextLines lines={t.info.hours.lines} />
              </p>
            </div>
          </div>

          <div className={s.infoItem}>
            <div className={s.infoIcon}>
              <PlaneIcon />
            </div>

            <div>
              <h4>
                {t.info.reply.title}
              </h4>

              <p>
                <TextLines lines={t.info.reply.lines} />
              </p>
            </div>
          </div>

          <div className={s.infoItem}>
            <div className={s.infoIcon}>
              <CameraIcon />
            </div>

            <div>
              <h4>
                {t.info.consultation.title}
              </h4>

              <p>
                <TextLines lines={t.info.consultation.lines} />
              </p>
            </div>
          </div>
        </div>

        <div className={s.buttons}>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className={s.instagram}
            onClick={() => trackCtaClick({
              label: 'instagram_contact',
              placement: 'contact_page',
              destination: INSTAGRAM_URL,
              destinationType: 'external_social',
            })}
          >
            <div className={s.icon}>
              <InstagramLogo />
            </div>

            <div className={s.text}>
              <strong>
                {t.buttons.instagram.title}
              </strong>

              <span>
                {t.buttons.instagram.text}
              </span>
            </div>

            <ArrowIcon />
          </a>

          <a
            href={LINE_URL}
            target="_blank"
            rel="noreferrer"
            className={s.line}
            onClick={() => trackCtaClick({
              label: 'line_contact',
              placement: 'contact_page',
              destination: LINE_URL,
              destinationType: 'external_booking',
            })}
          >
            <div className={s.icon}>
              <LineLogo />
            </div>

            <div className={s.text}>
              <strong>
                {t.buttons.line.title}
              </strong>

              <span>
                {t.buttons.line.text}
              </span>
            </div>

            <ArrowIcon />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
